import React, { useState } from "react";
import { useParams } from "react-router-dom";
import CompaniesApi from "~/admin/apis/companies.api";
import Card from "~/admin/components/Card";
import PageDataLoader from "~/admin/components/PageDataLoader";
import TabBar from "~/admin/components/TabBar";
import useDataLoading from "~/admin/hooks/useDataLoading";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";
import DocumentsTab from "~/admin/components/DocumentsTab";
import InformationsTab from "./InformationsTab";
import ConfirmationButton from "~/admin/components/ConfirmationButton";
import useLoader from "~/hooks/useLoader";
import Notifications from "~/admin/services/Notifications";
import useDemands from "~/admin/hooks/useDemandsContext";

export default function InfluencerPage() {
  const {
    demands: { demands },
  } = useDemands();

  const { setDemands } = useDemands();
  const params = useParams();
  const { setLayout } = useLayout();
  const [activeTab, setActiveTab] = useState("informations");
  const [company, setCompany] = useState(null);
  const [canValidate, setCanValidate] = useState(false);
  const [tabItems, setTabItems] = useState([
    {
      key: "informations",
      title: "Informations",
    },
    {
      key: "documents",
      title: "Documents",
    },
  ]);
  const dataLoading = useDataLoading();
  const loader = useLoader();

  useMount(() => {
    loadData();
  });

  const loadData = async () => {
    dataLoading.start();
    setCompany(null);

    let error = null;
    const company = await CompaniesApi.get(params.companyId).catch((e) => {
      error = e;
      return null;
    });

    dataLoading.stop(error);

    if (company) {
      setCompany(company);

      setTabItems([
        tabItems[0],
        {
          ...tabItems[1],
          notifs: company.user.documents.filter((document) => !document.isValid)
            .length,
        },
      ]);

      if (!company.user.documents.find((document) => !document.isValid)) {
        setCanValidate(true);
      }

      if (company.user.checkStatus !== "valid") {
        setLayout({
          title: "Demandes",
          activeMenuKeys: ["demands"],
        });
        setActiveTab("documents");
      } else {
        setLayout({
          title: "Utilisateurs",
          activeMenuKeys: ["users"],
        });
      }
    }
  };

  const changeTab = (key) => {
    setActiveTab(key);
  };

  const validateUser = async (companyId) => {
    loader.show();
    await CompaniesApi.validate(companyId).catch((e) => {
      Notifications.error("Erreur lors de la validation de l'utilisateur");
      return null;
    });

    setDemands({
      demands: demands - 1,
    });

    Notifications.success("Utilisateur validé avec succès");
    loader.hide();
    loadData();
  };

  return (
    <PageDataLoader isLoading={dataLoading.isLoading}>
      <>
        <div className="w-full h-[60px] border-b-2 border-slate-700 flex justify-end items-center px-10">
          {company && (
            <>
              {company.user.checkStatus !== "valid" && canValidate && (
                <ConfirmationButton
                  confirmationTitle="Valider l'utilisateur"
                  confirmationBody={`Êtes-vous sur de vouloir valider l'utilisateur ${company.name}`}
                  data={company.id}
                  onConfirm={validateUser}
                >
                  Valider l'utilisateur
                </ConfirmationButton>
              )}
              <div className="font-bold text-2xl ml-4">{company.name}</div>
            </>
          )}
        </div>
        <div className="p-6 overflow-auto">
          <Card>
            <TabBar
              items={tabItems}
              activeItem={activeTab}
              onChange={changeTab}
            />
            <div className="pt-4">
              {company && activeTab === "informations" && (
                <InformationsTab company={company} />
              )}
              {company && activeTab === "documents" && (
                <DocumentsTab user={company} reload={loadData} />
              )}
            </div>
          </Card>
        </div>
      </>
    </PageDataLoader>
  );
}
